import { MatDialog } from "@angular/material/dialog";
import { Component, ElementRef, ViewChild } from "@angular/core";
import { catchError, map, throwError } from "rxjs";
import { AdvisorsService } from "src/app/services/advisors.service";
import { AdvisorModalComponent } from "../../common/advisor-modal/advisor-modal.component";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-mastros",
  templateUrl: "./mastros.component.html",
  styleUrls: ["./mastros.component.scss"],
})
export class MastrosComponent {
  @ViewChild("scrollContent") scrollContent!: ElementRef;

  scrollSpeed = 200;

  advisors: any;
  maestro = [
    {
      id: 1,
      thumbnail: environment.assUrl + "assets/images/maestro/Ayaan-Ali.jpg",
      artist_name: "Ayaan Ali Bangash",
      about_us:
        "Ayaan Ali Bangash is an Indian classical musician who plays the sarod. Khan is the son of Amjad Ali Khan and often performs with his older brother Amaan Ali Khan, with whom he hosted the music talent show Sa Re Ga Ma. He has also released solo albums and collaborations with brother and father.",
      video: "",
    },
    {
      id: 2,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Amaan-Ali-Bangash.jpg",
      artist_name: "Amaan Ali Bangash",
      about_us:
        "Amaan Ali Khan (IAST: Aman Ali Khan) (born 1977) is an Indian classical musician who plays the sarod. Khan is the son of Ustad Amjad Ali Khan and often performs with his younger brother Ayaan Ali Khan, with whom he hosted the music talent show Sa Re Ga Ma.",
      video: "",
    },
    {
      id: 3,
      thumbnail:
        environment.assUrl +
        "assets/images/maestro/Ritesh-&-Rajnish-Mishra.jpg",
      artist_name: "Ritesh and Rajnish Mishra",
      about_us:
        "Duet singing in Indian Classical Music is considered a very difficult art, for it requires not only individual competence but, great amount of self-control to improvise and harmonize at the same time. The maestros Rajnish-Ritesh Mishra have put in everything to achieve such excellence under the guidance of the ever great, the 'Sun and Moon' of the Banaras Gharana, late Pt. Rajan Misra (Father) and Pt. Sajan Misra (Uncle). Enlivening the sixth generation of the family of great musicians, namely Pt. Ram Baksha Misra, Pt. Ganesh Ji Misra, Pt. Sursahai Misra, Pt. Hanuman Misra  Pt. Gopal Misra, Pt. Rajan Misra  Pt. Sajan Misra, Rajnish-Ritesh are also blessed by Gayanacharya Pt. Bade Ramdas Ji Misra, His Holiness Satguru Jagjit Singh Ji and have received knowledge of the art from a galaxy of musician relatives and friends.They have performed at most prestigious concerts all over the world. Their work with famous composer Micheal Nymen has been released as an album (SANGAM) selling worldwide. They have sung a song 'Mahadeva' in the album 'Rise' that has been nominated for the prestigious 'Grammy Awards'. They have given background score to the audio book by Penguine & ANB publisher.The maestros are 'A' grade vocalists of All India Radio and Television and have been awarded the prestigious 'Yuva Ratna Award' for the year 1999. They have also received the prestigious 'Sangeet Natak Akademi's Ustad Bismillah Khan Award' for the year 2008 and have been conferred the 'Sangeet Samriddhi Samman' for the year 2010.",
      video: "",
    },
    {
      id: 4,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Suresh-Talwarkar.jpg",
      artist_name: "Suresh Talwarkar",
      about_us:
        "Suresh Talwarkar is a tabla connoisseur. Initially trained under his father Dattatrey Talwarkar, he later mastered his art under tabla players Pandharinath Nageshkar and Vinayakrao Ghangrekar. Talwarkar has spread his teachings extensively all over the world including the United States, Europe, and Africa. He has received various awards some of them being - Padma Shri in 2013, All India Radio Award in 1966, Sangeet Natak Akademi Award in 2004, Awarded by The President of India Dr. A.P.J. Abdul Kalam Azad.",
      video: "",
    },
    {
      id: 5,
      thumbnail: environment.assUrl + "assets/images/maestro/Akram-khan.jpg",
      artist_name: "Akram Khan",
      about_us:
        "Akram Khan hails from the famous Ajrada gharana of tabla. Akram Khan belongs to the 7th (seventh) unbroken generation in his family, who is carrying the art form forward. Since his childhood he has been trained under the guidance of Ustad Mohd Shafi Khan and later on from Ustad Niazu Khan. He has accompanied his father Ustad Hashmat Ali Khan to various parts of the world to spread the name of Ajrada Gharana. He has also completed his Sangeet Visharadh from Chandigarh and Prabhakar and Sangeet Praveen from Allahabad. He has been honoured by All India Radio and ICCR for his contribution to the art. In 1993-94 he was appointed as visiting lecturer and was one of the faculty members at University Of Washington, Seattle, USA. Akram Khan was also fortunate to be part of the 50 years of independence celebration, which took place in Australia with Pt. Bhajan Sopori. He was also a part of the celebration of 60 years of Parliament House in New Delhi. He was also the tabla accompaniment for late Pt. Debu Chowdhuri in front of the Honble members of Parliament including Honble Prime Minister Dr. Manmohan Singh. His aim is to share his experience and explain the finest quality of the art of Tabla, to upcoming generations.",
      video: "",
    },
    {
      id: 6,
      thumbnail:
        environment.assUrl + "assets/images/maestro/Kaushiki-Chakraborty.jpg",
      artist_name: "Kaushiki Chakraborty",
      about_us:
        "Kaushiki Chakraborty is an Indian classical vocalist and the daughter of Ajoy Chakraborty. Groomed at Sangeet Research Academy, she is one of the exponents of Patiala gharana. Her repertoire covers Khyals and 'semi-classical' Thumris. At age ten, she started learning Indian classical music at the academy of Jnan Prakash Ghosh who was also her father's guru. Later, she joined the ITC Sangeet Research Academy from where she graduated in 2004, and was also groomed by her father at Shrutinandan, his school of music in Kolkata. She has not only specialized in rendering of Khayals and Thumri but she has also learned Carnatic music from Vidwan Balamurali Krishna from 2002. Kaushiki Chakraborty has participated in many major concerts. Apart from rendering Khayal in her performances, she has occasionally adopted lighter forms of music. She performed at the Doverlane Music Conference from the age of 20 and continued participating for the next 5 years. In her recitals, she presents a mature and rhythmical swing succeeded by unrestrained taans in three and-a-half octaves. She has performed extensively across India and abroad and has been acclaimed as 'torchbearer of the Patiala tradition' from India for her musical performances. Kaushiki Chakraborty has formed an exclusive women's musical group called the 'Sakhi' (meaning, friend) which is a forerunner in classical music in the country to 'celebrate womanhood' and as a dedication to the famous mythological and historical women of India. She has been the recipient of many awards. She received the Jadu Bhatta award in 1995, favourably mentioned and appreciated after her opening song at the 27th annual ITC Sangeet Sammelan in New Delhi in 1998, and received Outstanding Young Person in 2000. She received the BBC Award (2005) for outstanding achievement in music when she was 25 years old. She has also received Sangeet Natak Academys Ustad Bismillah Khan Puraskar in 2010 for Hindustani Vocal Music, and the 2013 Aditya Birla Kalakiran Puraskar. She has also received 'Shera Bangali Samman 2017' by ABP ANANDA.",
      video: "",
    },
  ];

  ngOnInit(): void {}

  constructor(private adivce: AdvisorsService, private dialog: MatDialog) {}

  getdata() {
    this.adivce
      .getAdvisor()
      .pipe(
        map((res: any) => {
          this.advisors = res.details;
          this.advisors.reverse();
          // console.log(this.advisors);
        }),
        catchError((error) => {
          return throwError(error.message || error);
        })
      )
      .subscribe();
  }

  transform(text: string): string {
    const words = text.split(" ");
    if (words.length > 50) {
      return words.slice(0, 50).join(" ") + " .....";
    } else {
      return text;
    }
  }

  openVideo(id: string) {
    // this.adivce.getAdvisorById(id).pipe(
    //   map((res: any) => {
    //     this.maestro = res.details;
    //     console.log(this.maestro);
    //     this.openDialog();
    //   }),
    //   catchError(error => {
    //     return throwError(error.message || error)
    //   })
    // ).subscribe()
  }

  scrollLeft() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft - this.scrollSpeed,
      behavior: "smooth",
    });
  }

  scrollRight() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft + this.scrollSpeed,
      behavior: "smooth",
    });
  }

  openDialog(id: number) {
    this.dialog.open(AdvisorModalComponent, {
      enterAnimationDuration: "400ms",
      data: {
        title: this.maestro[id - 1].artist_name,
        discription: this.maestro[id - 1].about_us,
        img: this.maestro[id - 1].thumbnail,
      },
    });
  }
}
